import {UyapRequest} from "./UyapRequest";

export interface KisiSorgulaError {
    errorCode: string;
    message: string;
}

export const KisiSorgulaErrorMessages = {
    INVALID_TC: {
        errorCode: 'INVALID_TC',
        message: 'Geçersiz T.C. Kimlik Numarası. Lütfen 11 haneli geçerli bir T.C. Kimlik Numarası giriniz.'
    },
    TC_NOT_FOUND: {
        errorCode: 'TC_NOT_FOUND',
        message: 'T.C. Kimlik Numarası bulunamadı. Lütfen bilgilerinizi kontrol ediniz.'
    },
    // TODO: errorCode ile eslestirilecek. "Sunucudan anlamli veri alinamadi"
    UYAP_CONNECTION_ERROR: {
        errorCode: 'PRTL_GNL_10001-55',
        message: 'Uyap kaynakli bağlantı hatası. Lütfen daha sonra tekrar deneyiniz.'
    },
    AUTHORIZATION_ERROR: {
        errorCode: 'AUTHORIZATION_ERROR',
        message: 'Bu işlem için yetkiniz bulunmamaktadır.'
    },
    SESSION_EXPIRED: {
        errorCode: 'SESSION_EXPIRED',
        message: 'Oturumunuzun süresi dolmuş. Lütfen tekrar giriş yapınız.'
    },
    SYSTEM_MAINTENANCE: {
        errorCode: 'SYSTEM_MAINTENANCE',
        message: 'Sistem bakımda. Lütfen daha sonra tekrar deneyiniz.'
    },
    RATE_LIMIT_EXCEEDED: {
        errorCode: 'RATE_LIMIT_EXCEEDED',
        message: 'Çok fazla sorgu gönderildi. Lütfen bir süre bekleyip tekrar deneyiniz.'
    },
    UNKNOWN_ERROR: {
        errorCode: 'UNKNOWN_ERROR',
        message: 'Uyap kaynaklı sorgu yapılamadı, tekrar deneyiniz.'
    }
} as const;

export interface KisiSorgulaTalep {
    tcKimlikNo: string
}

export interface KisiSorgulaCevap {
    olumKaydi: boolean,
    sorguTuru: number,
    kisiKurumID: number,
    tcKimlikNo: string,
    adi: string,
    soyadi: string,
    babaAdi: string,
    anaAdi: string,
    dogumTarihiStr: string,
    cinsiyeti: string,
}

export default class KisiSorgula extends UyapRequest<KisiSorgulaTalep, KisiSorgulaCevap> {
    delayTime = 1000;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Kişi sorgulanıyor...";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "kisi_" + this.talepData.tcKimlikNo
        };
    }

    getMockResponse(): any {
        return {"kisiKurumID":72835111,"tcKimlikNo":"25624971111","adi":"HÜ*****","soyadi":"TO***","cinsiyeti":"E","anaAdi":"DU**","babaAdi":"DU***","dogumTarihiStr":"*6/*7/1981","sorguTuru":0,"olumKaydi":false};
        // Uyapdan gelen hatalı sorgu
        // return {"sorguTuru":0,"olumKaydi":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'kisiSorgula.ajx';
    }

    async parse(data: any): Promise<KisiSorgulaCevap> {
        if (!data.kisiKurumID)
            throw new Error("UYAP'dan anlamlı veri alınamadı.");

        return data;
    }

}
